import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "d-flex justify-content-end page-heading-toolbar" }
const _hoisted_3 = { class: "page-heading-toolbar--col" }
const _hoisted_4 = { class: "page-body pb-5 mb-5" }
const _hoisted_5 = { class: "payments-table-box mt-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "payments-table-box--head" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Transactions")
], -1)
const _hoisted_7 = {
  key: 0,
  style: {"padding":"10px 0 10px 20px"},
  class: "subtitle date-group-title"
}
const _hoisted_8 = { class: "pseudo-table--footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChoosePeriodSelect = _resolveComponent("ChoosePeriodSelect")!
  const _component_PageMainHeading = _resolveComponent("PageMainHeading")!
  const _component_AppPaymentsHeading = _resolveComponent("AppPaymentsHeading")!
  const _component_AppPaymentsBody = _resolveComponent("AppPaymentsBody")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_TableRow = _resolveComponent("TableRow")!
  const _component_AppTableAccordion = _resolveComponent("AppTableAccordion")!
  const _component_TableFooter = _resolveComponent("TableFooter")!
  const _component_AppTableController = _resolveComponent("AppTableController")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageMainHeading, { title: "Payments" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_ChoosePeriodSelect, { onFilterChange: _ctx.changeFilterHandler }, null, 8, ["onFilterChange"])
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_AppTableController, {
          "show-table": !!_ctx.getData.length,
          "empty-key": "payments",
          "empty-icon": "payments"
        }, {
          default: _withCtx(() => [
            _hoisted_6,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getData, (data) => {
              return (_openBlock(), _createElementBlock("div", {
                key: data.id
              }, [
                (data[0].length)
                  ? (_openBlock(), _createElementBlock("h3", _hoisted_7, _toDisplayString(data[0]), 1))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data[1], ({
                        description,
                        product,
                user,
                        amount,
                date,
                        status,
                id,
                        paymentInfo,
                        paymentType,
                userInfo
                      }, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: idx,
                    class: "date-group"
                  }, [
                    _createVNode(_component_AppTableAccordion, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_TableRow, { class: "user-table-row" }, {
                          content: _withCtx(() => [
                            _createVNode(_component_Accordion, null, {
                              heading: _withCtx(() => [
                                _createVNode(_component_AppPaymentsHeading, {
                                  "payment-type": paymentType,
                                  description: description,
                                  user: user,
                                  amount: amount,
                                  date: date,
                                  status: status
                                }, null, 8, ["payment-type", "description", "user", "amount", "date", "status"])
                              ]),
                              body: _withCtx(() => [
                                _createVNode(_component_AppPaymentsBody, {
                                  id: id,
                                  product: product,
                                  user: user,
                                  "user-location": userInfo,
                                  status: status,
                                  payment: paymentInfo,
                                  "payment-type": paymentType,
                                  date: date,
                                  onCreateRefund: _ctx.createRefund
                                }, null, 8, ["id", "product", "user", "user-location", "status", "payment", "payment-type", "date", "onCreateRefund"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]))
                }), 128))
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_TableFooter, {
                "count-text": _ctx.paginationCapture,
                pagination: {
                total: _ctx.paginationTotal,
                current: _ctx.currentPage
              },
                "per-page": _ctx.initialViewConfiguration.perPage,
                "total-rows": _ctx.totalRows,
                "use-select": true,
                onChangePage: _ctx.changeCurrentPageHandler,
                onChangePerPage: _ctx.changePerPageHandler
              }, null, 8, ["count-text", "pagination", "per-page", "total-rows", "onChangePage", "onChangePerPage"])
            ])
          ]),
          _: 1
        }, 8, ["show-table"])
      ])
    ])
  ]))
}